import React, { useState } from 'react'
import { OrdersApi } from 'api';
import {Order, CreateOrder, getOrdersFilters, DonationSettings } from 'types';
import { getAPIErrorMessage } from 'lib/errorHandling';


interface OrderHookInfo {
  orderErrorMessage: string | undefined;
  orders: Array<any>;
  plasticsPrice: number | undefined;
  treesPrice: number | undefined;
  getOrders: (filters: getOrdersFilters) => void;
  getDonationSettings: () => void;
  updateDonationSettings: (data: DonationSettings) => Promise<void>;
  clearError: () => void;
  createOrder: (order:CreateOrder) => void;
  clearOrders: () => void
}

function useOrdersHook(): OrderHookInfo {
  
  const [orderErrorMessage, setOrderErrorMessage] = useState<string>();
  const [orders, setOrders] = useState<Array<any>>([])
  const [plasticsPrice, setPlasticsPrice] = useState<number>();
  const [treesPrice, setTreesPrice] = useState<number>();

  const setError = (err: any) => {
    const message = getAPIErrorMessage(err);
    setOrderErrorMessage(message)
  }

  const clearError = () => {
    setOrderErrorMessage(undefined);
  }

  const getOrders = async (filters: getOrdersFilters) => {
    try {
      const orders = await OrdersApi.getOrders(filters);
      setOrders(orders)
    } catch (err) {
      setOrders([])
      setError(err)
      throw err
    }
  }

  const getDonationSettings = async () => {
    try {
      const donationSettings = await OrdersApi.getDonationSettings();
      setPlasticsPrice(donationSettings.plasticsPrice)
      setTreesPrice(donationSettings.treesPrice)
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const updateDonationSettings = async (data: DonationSettings): Promise<void> => {
    try {
      return await OrdersApi.updateDonationSettings(data);
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const clearOrders = () =>{
    setOrders([])
  }

  const createOrder = async (order:CreateOrder) => {
    try {
      await OrdersApi.createOrder(order);
    } catch (err) {
      setError(err)
      throw err;
    }
  }

  return {
    orderErrorMessage,
    orders,
    plasticsPrice,
    treesPrice,
    getOrders,
    updateDonationSettings,
    getDonationSettings,
    createOrder,
    clearError,
    clearOrders
  }
}


export default useOrdersHook;